// Currency.js — currency rate table with code search + 10-per-page pagination.
import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IndexTemplate, Loading } from "../../utils/InlineComponents";
import { AppContext } from "../../HomePage";
import { UserService } from "../../service/UserService";

const Currency = () => {
    const { t, setError } = React.useContext(AppContext);
    const [items, setItems] = useState([]);
    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const userService = new UserService();

    useEffect(() => { search(); /* eslint-disable-next-line */ }, []);
    const search = () => {
        setLoading(true);
        userService.getUserBasedCurrencies().then(data => { setItems(data); setLoading(false); })
            .catch(error => { setError(error); setError(null); setLoading(false); });
    };

    if (loading) return <div style={{ textAlign: 'center' }}><Loading /></div>;

    const q = query.trim().toLowerCase();
    const filtered = q ? items.filter(i => (i.label || "").toLowerCase().includes(q)) : items;

    return (
        <React.Fragment>
            <span className="p-input-icon-left" style={{ display: 'block', maxWidth: 260, marginBottom: 10 }}>
                <i className="pi pi-search" />
                <InputText value={query} onChange={(e) => setQuery(e.target.value)}
                           placeholder={t('account.prefs.currency_search', 'Search currency code')} style={{ width: '100%' }} />
            </span>
            <DataTable value={filtered} emptyMessage={t('actions.empty_message', 'No records')} paginator rows={10} className="p-datatable-sm">
                <Column body={IndexTemplate} style={{ width: '3em' }} />
                <Column field="label" header={t('account.headers.currency', 'Currency')} sortable style={{ width: '8em' }} />
                <Column field="value" header={t('account.headers.currency_value', 'Value')} sortable />
            </DataTable>
        </React.Fragment>
    );
};
export default Currency;
